/**
 * ``/workspace/reports`` route group — Voice of X parent shell.
 *
 * File-based routing requires a parent ``route.tsx`` for any nested
 * ``$param.tsx`` segments (otherwise ``$reportId`` never registers).
 *
 * Pattern mirrors ``workspace/projects/route.tsx`` (see file header
 * there): the shell renders only an ``<Outlet />`` because the hub
 * (list) and detail surfaces own DIFFERENT headers — sharing one here
 * would stack two headers in the detail view.
 */

import { Outlet, createFileRoute } from "@tanstack/react-router";

import { validateWorkspaceSearch } from "@/features/workspace-router";

export const Route = createFileRoute("/_authed/workspace/reports")({
  validateSearch: validateWorkspaceSearch,
  component: ReportsShell,
});

function ReportsShell() {
  return <Outlet />;
}
